
import { useEffect } from 'react';
import { useUserOperations } from './hooks/useUserOperations';
import { useRealtimeUpdates } from './hooks/useRealtimeUpdates';

export function useUserManagement() {
  const {
    users,
    isLoading,
    fetchUsers,
    handleDeleteUser,
    handleToggleUserStatus,
    handleToggleUserRole,
    handleAddUser
  } = useUserOperations();

  useRealtimeUpdates(fetchUsers);

  useEffect(() => {
    fetchUsers();
  }, []);

  return { 
    users, 
    isLoading, 
    fetchUsers, 
    handleDeleteUser, 
    handleToggleUserStatus, 
    handleToggleUserRole, 
    handleAddUser 
  };
}
